export default __webpack_public_path__ + "static/media/Icon-PurchaseOrders-White.fbb44c76.svg";